<template>
    <div class="warning d-flex flex-column align-items-center justify-content-center">
        <p class="m-0 text-center" style="font-size: 14px;">
            กรุณายอมรับเงื่อนไขการให้บริการ COD เพื่อยืนยันการทำรายการ
            <span class="read-here" @click="$emit('onOpen')">อ่านรายละเอียดที่นี่</span>
        </p>
        <p class="mt-2 mb-0 text-center" style="font-size: 14px;">
            (หากยอมรับเงื่อนไขแล้วรบกวน refresh หน้าอีกครั้ง)
        </p>

        <ModalCodAgreement 
            :open="openModal"
            :memberServiceToken="memberServiceToken"
            @close="$emit('onClose')"
        />
    </div>
</template>

<script>
    import ModalCodAgreement from "@/components/Modals/ModalCodAgreement";

    export default {
        name: 'NoticeCodAgreement',
        props: {
            memberServiceToken: String,
            openModal: Boolean
        },
        data() {
            return {
                open: false,
            }
        },
        components: {
            ModalCodAgreement
        },
    }
</script>

<style scoped>
    .warning {
        background-color: #fcf8e3;
        color: #8a6d3b;
        width: 100%;
        padding: 10px;
    }
    .read-here {
        font-size: 14px;
        cursor: pointer;
        color: #007bff;
    }
    .read-here:hover {
        color: #0056b3;
    }
</style>
